import axios from 'axios';

/**
 * A simplified notification service that replaces Firebase
 * This service uses the browser's native Notification API
 */
export const initializeNotifications = async (): Promise<string> => {
  try {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      throw new Error('Notification permission denied');
    }

    // Generate a simple device identifier
    // In a real implementation, you might want to use a more robust solution
    // like a UUID library or fingerprinting
    const deviceId = `web-${Date.now()}-${Math.random().toString(36).substring(2, 10)}`;
    
    // Register with backend
    await axios.post('/api/notifications/register-token', {
      token: deviceId,
      type: 'web',
    });

    return deviceId;
  } catch (error) {
    console.error('Error initializing notifications:', error);
    throw error;
  }
};

// Function to show a notification
export const showNotification = (title: string, body: string) => {
  if (Notification.permission === 'granted') {
    new Notification(title, { body });
  }
};
